export const CUSTOM_UPGRADE_STATUS_ACTIVE = "active";
export const CUSTOM_UPGRADE_STATUS_ARCHIVED = "archived";
